import { Col, Row } from "antd";
import "./Header_Bottom.scss";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  getHeadersSports,
  getHeadersKids,
  getHeadersMan,
  getHeadersWoman,
  getHeadersBrands,
  getHeadersTrend,
  getHeadersSales,
} from "../../../services/headers/headers";

function Header_Bottom() {
  const [headersWoman, setHeadersWoman] = useState([]);
  const [headersMan, setHeadersMan] = useState([]);
  const [headersKids, setHeadersKids] = useState([]);
  const [headersSports, setHeadersSports] = useState([]);
  const [headersBrands, setHeadersBrands] = useState([]);
  const [headersTrend, setHeadersTrend] = useState([]);
  const [headersSales, setHeadersSales] = useState([]);

  useEffect(() => {
    const fetchApi = async () => {
      const contentHeadersWoman = await getHeadersWoman();
      const contentHeadersMan = await getHeadersMan();
      const contentHeadersKids = await getHeadersKids();
      const contentHeadersSports = await getHeadersSports();
      const contentHeadersBrands = await getHeadersBrands();
      const contentHeadersTrend = await getHeadersTrend();
      const contentHeadersSales = await getHeadersSales();

      setHeadersWoman(contentHeadersWoman);
      setHeadersMan(contentHeadersMan);
      setHeadersKids(contentHeadersKids);
      setHeadersSports(contentHeadersSports);
      setHeadersBrands(contentHeadersBrands);
      setHeadersTrend(contentHeadersTrend);
      setHeadersSales(contentHeadersSales);
      // console.log(contentHeadersTrend);
    };
    fetchApi();
  }, []);

  return (
    <ul className="header-bottom">
      <li className="menu-item">
        Nữ
        <div className="dropdown">
          <Row gutter={[20, 20]}>
            {headersWoman.map((item) => (
              <React.Fragment key={`woman-${item.id}`}>
                <Col xxl={8} xl={8} key={`woman-cate-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Mua sắm theo danh mục</div>

                    <div className="dropdown-list">
                      <div className="dropdown-row">
                        {item.cate.map((cate) => (
                          <Link
                            to={`/${item.name}/${cate.key}`}
                            className="dropdown-link"
                            key={`woman-cate-item-${cate.id}`}
                          >
                            <div className="dropdown-item">{cate.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={8} xl={8} key={`woman-featured-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Nổi bật</div>

                    <div className="dropdown-list">
                      <div className="dropdown-row featured">
                        {item.featured.map((f) => (
                          <Link
                            to={`/Woman/${f.key}`}
                            className="dropdown-link"
                            key={`woman-featured-item-${f.id}`}
                          >
                            <div className="dropdown-item">{f.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={8} xl={8} key={`woman-img-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-list box-img">
                      {item.box_img.map((itemImg, index) => (
                        <Link
                          className="dropdown-link box-img"
                          key={`woman-boximg-${item.id}-${index}`}
                        >
                          <div className="dropdown-item">
                            <img src={itemImg.thumbnail} alt="Thumbnail" />
                            <div className="sub">{itemImg.name}</div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </li>

      <li className="menu-item">
        Nam
        <div className="dropdown">
          <Row gutter={[20, 20]}>
            {headersMan.map((item) => (
              <React.Fragment key={`man-${item.id}`}>
                <Col xxl={8} xl={8} key={`man-cate-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Mua sắm theo danh mục</div>

                    <div className="dropdown-list">
                      <div className="dropdown-row">
                        {item.cate.map((cate) => (
                          <Link
                            to={`/category/${cate.key}`}
                            className="dropdown-link"
                            key={`man-cate-item-${cate.id}`}
                          >
                            <div className="dropdown-item">{cate.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={8} xl={8} key={`man-featured-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Nổi bật</div>

                    <div className="dropdown-list">
                      <div className="dropdown-row featured">
                        {item.featured.map((f) => (
                          <Link
                            to={`/featured/${f.key}`}
                            className="dropdown-link"
                            key={`man-featured-item-${f.id}`}
                          >
                            <div className="dropdown-item">{f.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={8} xl={8} key={`man-img-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-list box-img">
                      {item.box_img.map((itemImg, index) => (
                        <Link
                          className="dropdown-link box-img"
                          key={`man-boximg-${item.id}-${index}`}
                        >
                          <div className="dropdown-item">
                            <img src={itemImg.thumbnail} alt="Thumbnail" />
                            <div className="sub">{itemImg.name}</div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </li>

      <li className="menu-item">
        Trẻ em
        <div className="dropdown">
          <Row gutter={[20, 20]}>
            {headersKids.map((item) => (
              <React.Fragment key={`kids-${item.id}`}>
                <Col xxl={6} xl={6} key={`kids-cate-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Mua sắm theo danh mục</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row common kids">
                        {item.cate.map((cate) => (
                          <Link
                            to={`/${item.name}/${cate.key}`}
                            className="dropdown-link"
                            key={`kids-cate-${cate.id}`}
                          >
                            <div className="dropdown-item">{cate.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={6} xl={6} key={`kids-brand-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Thương hiệu nổi tiếng</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row featured">
                        {item.popular_brands.map((f) => (
                          <Link
                            to={`/featured/${f.key}`}
                            className="dropdown-link"
                            key={`kids-brand-${f.id}`}
                          >
                            <div className="dropdown-item">{f.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={4} xl={4} key={`kids-gender-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Giới tính</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row featured">
                        {item.gender.map((g) => (
                          <Link
                            to={`/featured/${g.key}`}
                            className="dropdown-link"
                            key={`kids-gender-${g.id}`}
                          >
                            <div className="dropdown-item">{g.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={8} xl={8} key={`kids-age-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Độ tuổi</div>
                    <div className="dropdown-list box-img common kids">
                      {item.box_img.map((itemImg, index) => (
                        <Link
                          className="dropdown-link box-img common kids"
                          key={`kids-box-${item.id}-${index}`}
                        >
                          <div className="dropdown-item">
                            <img src={itemImg.thumbnail} alt="Thumbnail" />
                            <div className="sub">{itemImg.name}</div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </li>

      <li className="menu-item">
        Thể thao
        <div className="dropdown">
          <Row gutter={[20, 20]}>
            {headersSports.map((item) => (
              <React.Fragment key={`sports-${item.id}`}>
                <Col xxl={6} xl={6} key={`sports-cate-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Mua sắm theo danh mục</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row common sports">
                        {item.cate.map((cate) => (
                          <Link
                            to={`/category/${cate.key}`}
                            className="dropdown-link"
                            key={`sports-cate-${cate.id}`}
                          >
                            <div className="dropdown-item">{cate.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={6} xl={6} key={`sports-vintage-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Phong cách cổ điển</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row featured">
                        {item.vintage.map((v) => (
                          <Link
                            to={`/featured/${v.key}`}
                            className="dropdown-link"
                            key={`sports-vintage-${v.id}`}
                          >
                            <div className="dropdown-item">{v.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={4} xl={4} key={`sports-league-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Giải đấu</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row featured">
                        {item.league.map((l) => (
                          <Link
                            to={`/featured/${l.key}`}
                            className="dropdown-link"
                            key={`sports-league-${l.id}`}
                          >
                            <div className="dropdown-item">{l.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={8} xl={8} key={`sports-box-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Thể thao</div>
                    <div className="dropdown-list box-img common sports">
                      {item.box_img.map((itemImg, index) => (
                        <Link
                          className="dropdown-link box-img common sports"
                          key={`sports-box-${item.id}-${index}`}
                        >
                          <div className="dropdown-item">
                            <img src={itemImg.thumbnail} alt="Thumbnail" />
                            <div className="sub">{itemImg.name}</div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </li>

      <li className="menu-item">
        Thương hiệu
        <div className="dropdown">
          <Row gutter={[20, 20]}>
            {headersBrands.map((item) => (
              <React.Fragment key={`brand-${item.id}`}>
                <Col xxl={16} xl={16} key={`brand-list-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Thương hiệu nổi tiếng</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row">
                        {item.popular_brands.map((p, index) => (
                          <Link
                            to={`/category/${p.key}`}
                            className="dropdown-link brands"
                            key={`brand-item-${item.id}-${p.id}-${index}`}
                          >
                            <div className="dropdown-item">{p.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={8} xl={8} key={`brand-img-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-list box-img">
                      {item.box_img.map((itemImg, index) => (
                        <Link
                          className="dropdown-link box-img"
                          key={`brand-box-${item.id}-${index}`}
                        >
                          <div className="dropdown-item">
                            <img src={itemImg.thumbnail} alt="Thumbnail" />
                            <div className="sub">{itemImg.name}</div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </li>

      <li className="menu-item">
        Trendding
        <div className="dropdown">
          <Row gutter={[20, 20]}>
            {headersTrend.map((item) => (
              <React.Fragment key={`trend-${item.id}`}>
                <Col xxl={6} xl={6} key={`trend-woman-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Xu hướng nữ</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row common sports">
                        {item.trend_woman.map((w) => (
                          <Link
                            to={`/category/${w.key}`}
                            className="dropdown-link"
                            key={`trend-woman-${w.id}`}
                          >
                            <div className="dropdown-item">{w.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={6} xl={6} key={`trend-man-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Xu hướng nam</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row featured">
                        {item.trend_man.map((m) => (
                          <Link
                            to={`/featured/${m.key}`}
                            className="dropdown-link"
                            key={`trend-man-${m.id}`}
                          >
                            <div className="dropdown-item">{m.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={4} xl={4} key={`trend-items-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Các mục thịnh hành</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row featured">
                        {item.trend_items.map((i) => (
                          <Link
                            to={`/featured/${i.key}`}
                            className="dropdown-link"
                            key={`trend-item-${i.id}`}
                          >
                            <div className="dropdown-item">{i.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={8} xl={8} key={`trend-img-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Xu hướng</div>
                    <div className="dropdown-list box-img common sports">
                      {item.box_img.map((itemImg, index) => (
                        <Link
                          className="dropdown-link box-img common sports"
                          key={`trend-box-${item.id}-${index}`}
                        >
                          <div className="dropdown-item">
                            <img src={itemImg.thumbnail} alt="Thumbnail" />
                            <div className="sub">{itemImg.name}</div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </li>

      <li className="menu-item sales">
        Sales
        <div className="dropdown">
          <Row gutter={[20, 20]}>
            {headersSales.map((item) => (
              <React.Fragment key={`sales-group-${item.id}`}>
                {/* Giảm giá cho nữ */}
                <Col xxl={8} xl={8} key={`sales-woman-col-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Giảm giá cho nữ</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row">
                        {item.sales_woman.map((w) => (
                          <Link
                            to={`/category/${w.key}`}
                            className="dropdown-link"
                            key={`sales-woman-item-${item.id}-${w.id}`}
                          >
                            <div className="dropdown-item">{w.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Giảm giá cho nam */}
                <Col xxl={8} xl={8} key={`sales-man-col-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-title">Giảm giá cho nam</div>
                    <div className="dropdown-list">
                      <div className="dropdown-row">
                        {item.sales_man.map((m) => (
                          <Link
                            to={`/featured/${m.key}`}
                            className="dropdown-link"
                            key={`sales-man-item-${item.id}-${m.id}`}
                          >
                            <div className="dropdown-item">{m.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Hình ảnh giảm giá */}
                <Col xxl={8} xl={8} key={`sales-img-col-${item.id}`}>
                  <div className="dropdown-col">
                    <div className="dropdown-list box-img">
                      {item.box_img.map((itemImg, index) => (
                        <Link
                          className="dropdown-link box-img"
                          key={`sales-img-item-${item.id}-${index}`}
                        >
                          <div className="dropdown-item">
                            <img src={itemImg.thumbnail} alt="Thumbnail" />
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </li>
    </ul>
  );
}

export default Header_Bottom;
